import React, { useMemo, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";

const t = (id?: string, values?: Record<string, any>) => {
  if (!id) return "";
  return <FormattedMessage id={id} defaultMessage={"¿ " + id + " ¿"} values={values} />;
};

export const useAppText = () => {
  const intl = useIntl();
  const currentLocale = intl.locale;
  const tString = useCallback(
    (id?: string, values?: Record<string, any>) => {
      return intl.formatMessage({ id, defaultMessage: "¿ " + id + " ¿" }, values);
    },
    [intl],
  );

  return useMemo(() => {
    // retourne api de traduction
    return {
      t,
      tString,
      currentLocale,
    };
  }, [currentLocale, tString]);
};

export type UseAppTextReturn = ReturnType<typeof useAppText>;

const AppText = ({ id, values }: { id: string; values?: Record<string, any> }) => {
  const { t } = useAppText();
  //mes superfonctions autour etc pour rajouter click modif rapide
  return <>{t(id, values)}</>;
};

export default AppText;
